class LqdHeaderMenuHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initSubmenu();
    this.initTransitionDelay();
    this.initMegamenu();

  }

  getDefaultSettings() {
    return {
      selectors: {
        mainNavElement: '.main-nav',
        transitionDelayElement: ('.lqd-submenu-cover .main-nav > .menu-item-has-children:not(.megamenu) > .nav-item-children'),
        megamenuElement: '.megamenu',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $mainNavElement: this.$element.find(selectors.mainNavElement),
      $transitionDelayElement: this.$element.find(selectors.transitionDelayElement),
      $megamenuElement: this.$element.find(selectors.megamenuElement),
    }
  }

  initSubmenu() {

    this.elements.$mainNavElement.liquidSubmenu();

  }

  initTransitionDelay() {

    this.elements.$transitionDelayElement.liquidTransitionDelay({
      elements: '> li',
      delayBetween: 70
    });

  }

  initMegamenu() {

    this.elements.$megamenuElement.liquidMegamenu();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdHeaderMenuHandler, { $element } );
};